module.exports = __webpack_public_path__ + "static/media/delivery1.29ac5c8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Delivery/images/delivery1.jpg
// module id = 324
// module chunks = 0